import React from 'react';
import PropTypes from 'prop-types';

import IconConnector from './icon-connector.jsx';
import IconArrow from './icon-arrow.jsx';

const InProgressIcon = ({ percentComplete, showConnector, showArrow }) => {
    if (!percentComplete) {
        return null;
    }
    let backgroundColor;
    let backgroundImage;
    const completeColour = '#83cb01';
    const incompleteColour = '#f0f2f3';
    const degrees = percentComplete * 180;
    if (percentComplete < 0.5) {
        backgroundColor = completeColour;
        backgroundImage =
            `linear-gradient(` +
            degrees +
            `deg, transparent 50%, ` +
            incompleteColour +
            ` 50%), linear-gradient(-` +
            degrees +
            `deg, ` +
            incompleteColour +
            ` 50%, transparent 50%)`;
    } else {
        backgroundColor = incompleteColour;
        backgroundImage =
            `linear-gradient(` +
            degrees +
            `deg, ` +
            completeColour +
            ` 50%, transparent 50%), linear-gradient(-` +
            degrees +
            `deg, transparent 50%, ` +
            completeColour +
            ` 50%)`;
    }
    return (
        <div className="in-progress-icon">
            {showConnector && <IconConnector />}
            {showArrow && <IconArrow />}
            <div className="rewards-icon-outer-circle" style={{ backgroundColor, backgroundImage }}>
                <div className="rewards-icon-inner-circle">
                    <div className="rewards-icon-percent">{Math.floor(percentComplete * 100)}%</div>
                </div>
            </div>
        </div>
    );
};

InProgressIcon.propTypes = {
    percentComplete: PropTypes.number,
    showArrow: PropTypes.bool,
    showConnector: PropTypes.bool,
};

InProgressIcon.displayName = 'InProgressIcon';

export default InProgressIcon;
